import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/App";
import { SiteHeader, SiteFooter, useMeta } from "@/components/site/Chrome";

export default function FreeVerify() {
  const [params] = useSearchParams();
  const [error, setError] = useState(null);
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false);
  useMeta("Opening your free exam — ExamRay");

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      try {
        const { data } = await api.post("/auth/magic/verify", { token: params.get("token") });
        await refresh();
        const es = await api.post("/exam-sessions", { cert_slug: data.cert_slug, exam_number: 0, mode: "free" });
        navigate(`/exam/${es.data.id}`);
      } catch (e) { setError(errMsg(e)); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional run-once: magic tokens are single-use
  }, []);

  return (
    <div className="er" data-testid="free-verify-page">
      <SiteHeader />
      <section className="er-page" style={{ maxWidth: 640 }}>
        <div className="er-buybox">
          <div className="er-rule" />
          <div style={{ padding: "30px 28px" }}>
            {error ? (
              <>
                <p className="er-label" style={{ color: "var(--ink-4)" }}>LINK PROBLEM</p>
                <h1 className="er-h2" style={{ marginTop: 12, fontSize: 24 }}>This link did not work.</h1>
                <p data-testid="magic-error" style={{ marginTop: 10, fontSize: 15, lineHeight: 1.6, color: "var(--ink-3)" }}>{error}</p>
                <p style={{ marginTop: 8, fontSize: 14, lineHeight: 1.6, color: "var(--ink-4)" }}>Magic links are single-use and expire after 24 hours. Request a fresh one and it opens straight into the exam.</p>
                <div style={{ marginTop: 22, display: "flex", gap: 10, flexWrap: "wrap" }}>
                  <Link to="/free" className="er-btn" data-testid="magic-retry-link">Send a new link</Link>
                  <Link to="/login" className="er-btn-secondary" data-testid="magic-login-link">Sign in instead</Link>
                </div>
              </>
            ) : (
              <>
                <p className="er-label" style={{ color: "var(--ink-4)" }}>FREE EXAM</p>
                <h1 className="er-h2" style={{ marginTop: 12, fontSize: 24 }} data-testid="magic-loading">Preparing your free exam…</h1>
                <p style={{ marginTop: 10, fontSize: 15, lineHeight: 1.6, color: "var(--ink-3)" }}>Signing you in and drawing your questions across every domain. The timer starts when the first question appears.</p>
              </>
            )}
          </div>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
